// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* region fill */
.em--waffle .em-cntrg,
.em--waffle .em-nutsrg {
    fill: #f2f2f2;
}
/*  muted nuts boundaries */
.em--waffle .em-bn-1,
.em--waffle .em-bn-2,
.em--waffle .em-bn-3,
.em--waffle .em-nutsrg [lvl='3'],
.em--waffle .em-nutsrg [lvl='2'],
.em--waffle .em-nutsrg [lvl='1'],
.em--waffle .em-bn-co {
    stroke-width: 0.1px;
}

/*  coastline  */
.em--waffle .em-bn-co {
    stroke: grey;
    stroke-width: 0.2px;
}

/*  country borders  */
.em--waffle .em-cntbn,
.em--waffle .em-cntbn-halo {
    opacity: 0.3;
}
.em-tooltip-wafflechart-container {
    max-width: 150px;
}
`, "",{"version":3,"sources":["webpack://./src/css/map-types/waffle.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;IAEI,aAAa;AACjB;AACA,2BAA2B;AAC3B;;;;;;;IAOI,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;;IAEI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB","sourcesContent":["/* region fill */\r\n.em--waffle .em-cntrg,\r\n.em--waffle .em-nutsrg {\r\n    fill: #f2f2f2;\r\n}\r\n/*  muted nuts boundaries */\r\n.em--waffle .em-bn-1,\r\n.em--waffle .em-bn-2,\r\n.em--waffle .em-bn-3,\r\n.em--waffle .em-nutsrg [lvl='3'],\r\n.em--waffle .em-nutsrg [lvl='2'],\r\n.em--waffle .em-nutsrg [lvl='1'],\r\n.em--waffle .em-bn-co {\r\n    stroke-width: 0.1px;\r\n}\r\n\r\n/*  coastline  */\r\n.em--waffle .em-bn-co {\r\n    stroke: grey;\r\n    stroke-width: 0.2px;\r\n}\r\n\r\n/*  country borders  */\r\n.em--waffle .em-cntbn,\r\n.em--waffle .em-cntbn-halo {\r\n    opacity: 0.3;\r\n}\r\n.em-tooltip-wafflechart-container {\r\n    max-width: 150px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
